import React, { useRef } from "react";
import {
  BaseTextField,
  PageHeaderWithTabs,
  FormSwitch,
  BaseCheckBox,
  SimpleTable,
  MasterLayoutMiddle, FooterInner, EmptyTable, AlertDialogue, AlertAction, AlertDialogueAdvance
} from "@dclab/dc-react-ui-kit";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { useEffect, useState } from "react";
import Moment from "moment";
import Edit from "../../assets/img/create-24px.svg";
import Delete from "../../assets/img/delete_forever-24px.svg";
import "./style.css";
import { DeleteNewsAndArticlesWebsite, deleteNewsWithAppId, getNewsWithAppId } from "./api";
import { getOrganizationData } from "../Organization/api";
import { saveAsDraft } from "../../components/DonationForm/Apis";
import { PagesAction } from "../../redux/actions/pages";
import { connect } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import { hideAlert, showAlert } from "../../redux/actions/alertActions";
import messages_content from '../../utils/messages.json';
const {
  token_expired,
  Your_changes_has_been_published,
  Your_changes_has_been_saved_as_draft,
  quick_access_limit_axeeded,
  remove_news_message
} = messages_content;
function NewsArticles(props) {
  const history = props.history;
  const [Title, setTitle] = React.useState('title')
  const [Loader, setLoader] = React.useState(true)
  const [value, setValue] = React.useState(0);
  const [News, setNews] = React.useState([]);
  const [specificRow, setSpecificRow] = React.useState([]);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [showAlert, setshowAlert] = useState(false);
  const [success, setsuccess] = useState(false);
  const [error, seterror] = useState(false);
  const unblockHandle = useRef();
  const [changes, setCheckChanges] = useState(false);
  const [saved_route, setRoute] = useState('');
  const [open, setAlertModal] = useState(false);
  const [organizationData, setOrganizationData] = useState([])
  const [homepageButton, setHomePageButton] = useState(false);
  const [QuickLimit, setQuickLimit] = useState(false);
  const [dischard_changes, setdischard_changes] = useState(0);
  const [pagesAll, setPagesAll] = useState({})
  const [getNewData, setNewData] = useState(false);
  const [integrateData, setIntegrateData] = useState({})
  const [ErrorFound, setErrorFound] = useState(false);
  const [canBeFeatured, setcanBeFeatured] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      props.alertHide()
    }, 8000)
  }, [props.alert.alertValue])
  useEffect(() => {
    unblockHandle.current = history.block((route) => {
      setRoute(route.pathname)
      changes && visibleModal()
      return changes === true ? false : true
    });
    return () => {
      unblockHandle.current = false
      !window.location.pathname.includes('videos') && localStorage.removeItem('videos')
    }
  }, [changes])
  function visibleModal() {
    setAlertModal(true)
  }
  useEffect(() => {
    const page_no = localStorage.getItem('newsArticles')
    setValue(page_no ? +page_no : 0);
    async function getorganization() {
      try {
        const token = localStorage.getItem('authToken')
        const orgId = localStorage.getItem('orgID')
        const getOraganization = await getOrganizationData(orgId, token);
        const orgIntegrateData = getOraganization?.data?.body?.data?.enabledIntegrations;
        const data = orgIntegrateData.deenweb?.pages;
        const oraganization_data = data?.articles;
       
        console.log("oraganization_data: ", oraganization_data)
        setHomePageButton(oraganization_data.enablePage)
        setChecked(oraganization_data.quickAccess)
        setNewData(false)
        setLoader(false)

        setIntegrateData(orgIntegrateData);
        setPagesAll(data);
        
        setOrganizationData(newData => [...organizationData, oraganization_data]);
        
       console.log("organizationData: ", organizationData)
        setTitle(oraganization_data.title);
        console.log("oraganization_data.title: ", oraganization_data.title)
        
      }
      catch (error) {
        setLoader(false)
        seterror(error.response && error.response.data.message)
        setTimeout(() => {
          seterror(false)
        }, 8000);
      }
    }
    getorganization()
  }, [getNewData])
  const handleChange = (event, newValue) => {
    changes && (Title === '' ? setErrorFound(true) : setAlertModal(true))
    !changes && setValue(newValue);
    !changes && localStorage.setItem('newsArticles', newValue)
    setdischard_changes(newValue)
  };
  useEffect(() => {
    GetNewsAndArticles();
  }, [])
  async function GetNewsAndArticles() {
    const token = localStorage.getItem("authToken");
    const orgId = localStorage.getItem("orgID");
    try {
      const resultArticles = await getNewsWithAppId(token, orgId, 'deenweb')
      const data = resultArticles.data.body.data;

      console.log("Articles: ", data)
      const sort = data.sort((a, b) => {
        return new Date(b.updatedAt) - new Date(a.updatedAt)
      })
      let dataTable = [];
      let featuredCounter = 0;
      sort.map((text, index) => {
        console.log("text: ", text)
        if (text?.featured) {
          featuredCounter += 1;
        }
        const dateStart = [Moment(text.publishFrom).format("MMM DD, YYYY"), Moment(text.publishFrom).format("h:mm A") + ' (EST)'];
        const dateEnd = [Moment(text.publishTo).format("MMM DD, YYYY"), Moment(text.publishTo).format("h:mm A") + ' (EST)'];
        const UnpublishDate = new Date(dateEnd).getFullYear()
        const status = text.status
        const statusChangeStart = new Date(dateStart) <= new Date();
        const statusChangeEnd = new Date(dateEnd) <= new Date();
        let array = [
          { type: "id", value: `${index <= 8 ? '0' + (index + 1) : index + 1}`, _id: text?._id, articleId: text.article?._id },
          {
            type: "url",
            name: "single_pic",
            src: text.article?.imageMetaData ? text.article?.imageMetaData.imageUrl : '',
          },
          {
            type: "string",
            name: "name",
            value: text.article ? text.article.title : '',
          },
          { type: "string", name: "frequency", value: text.article? text.article.category : '' },
          {
            type: "string",
            name: "vertical",
            value: dateStart,
          },
          {
            type: "string",
            name: UnpublishDate === 2099 ? "frequency" : "vertical",
            value: UnpublishDate === 2099 ? "Never" : dateEnd
          },
          {
            type: "status",
            status: status === 'Hidden' ? statusChangeEnd ? 'pending' : statusChangeStart ? 'pending' : 'schedule'
              : statusChangeEnd ? 'pending' : statusChangeStart ? 'success' : 'schedule',
            value: status === 'Hidden' ? statusChangeEnd ? 'Unpublished' : statusChangeStart ? 'Unpublished' : 'Scheduled'
              : statusChangeEnd ? 'Unpublished' : statusChangeStart ? 'Published' : 'Scheduled'
          },
        ]
        dataTable.push(array)
      })

      if (featuredCounter > 2) {
        setcanBeFeatured(false);
      }
      setNews(dataTable);
      setLoader(false)
    } catch (err) {
      console.log("Error is add news: ", err);
      setLoader(false)
      seterror(err.response && err.response.data.message)
      setTimeout(() => {
        seterror(false)
      }, 8000);
    }
  }
  const DeleteAlertFunc = (e) => {
    setSpecificRow(e);
    setOpenAlert(true);
  }
  const handleCancel = () => {
    setOpenAlert(false);
  }
  const handleClose = () => {
    setOpenAlert(false);
  };
  const object = [
    {
      label: "Contents",
      item: "Contents",
    },
    {
      label: "Page setup",
      item: "Page setup",
    },

  ];
  const saveChanges = async () => {
    const orgId = localStorage.getItem('orgID');
    const token = localStorage.getItem('authToken');
    if (Title === '') {
      setErrorFound(true)
    } else {
      const data = {
        enabledIntegrations: {
          ...integrateData,
          deenweb: {
            ...integrateData.deenweb,
            pages: {
              ...pagesAll,
              articles: {
                Titletitle: Title,
                status: homepageButton ? 'active' : 'inactive',
                enablePage: homepageButton,
                quickAccess: checked,
                lastEdited: new Date(),
                pageName: 'About Us',
              }
            }
          }
        }
      }
      // const data = {
      //   "addSelectedArrayData": {
      //       "enabledIntegrations.deenweb.pages.articles": {
      //         title: Title,
      //         status: homepageButton ? 'active' : 'inactive',
      //         enablePage: homepageButton,
      //         quickAccess: checked,
      //         lastEdited: new Date(),
      //       }
      //     },
      //   }
      try {
        await saveAsDraft(orgId, data, token);
        setshowAlert(true);
        setsuccess(true)
        setValue(dischard_changes);
        setAlertModal(false)
        if (saved_route) {
          props.history.push(saved_route)
        }
        setTimeout(() => {
          setshowAlert(false);
        }, 8000)
      } catch (err) {
        setAlertModal(false)
        seterror(err.response && err.response.data.message)
        setTimeout(() => {
          seterror(false)
        }, 8000);
      }
    }
  };
  const deleteServiceAction = async (e) => {
    setOpenAlert(false);
    setLoader(true)
    const token = localStorage.getItem("authToken");
    const orgId = localStorage.getItem('orgID');
    try {
      await deleteNewsWithAppId(token, orgId, 'deenweb', e[0].articleId)
      await DeleteNewsAndArticlesWebsite(token, e[0].articleId)
      props.alertShow(remove_news_message)
      const stateNews = News
      const NewsIndex = News.indexOf(e)
      stateNews.splice(NewsIndex, 1)
      setNews(stateNews)
      setLoader(false)
    } catch (err) {
      setLoader(false)
      seterror(err.response && err.response.data.message)
      setTimeout(() => {
        seterror(false)
      }, 8000);
    }
  }
  const checkChanges = (boolean) => {
    setCheckChanges(boolean)
  }
  const publish = async () => {
    let pages = props?.pages?.pages
    let lengthOfPages = pages.filter(text => text.quickAccess === true);
    const orgId = localStorage.getItem('orgID');
    const token = localStorage.getItem('authToken');
    if (Title === '') {
      setErrorFound(true)
    } else {
      const data = {
        enabledIntegrations: {
          ...integrateData,
          deenweb: {
            ...integrateData.deenweb,
            pages: {
              ...pagesAll,
              articles: {
                title: Title,
                status: homepageButton ? 'active' : 'inactive',
                enablePage: homepageButton,
                quickAccess: checked,
                lastEdited: new Date(),
                pageName: 'About Us',
              }
            }
          }
        }
      }
      if (!checked || organizationData.quickAccess || lengthOfPages.length < 6) {
        try {
          await saveAsDraft(orgId, data, token);
          setshowAlert(true);
          setsuccess('Publish');
          setCheckChanges(false)
          let Quick = pages.filter(text => text.name[0] !== "articles")
          Quick.push({
            name: ['articles'],
            quickAccess: checked
          })
          props.dispatchPagesAction(Quick)
          setTimeout(() => {
            setshowAlert(false)
          }, 8000)
        } catch (err) {
          seterror(err.response && err.response.data.message)
          setTimeout(() => {
            seterror(false)
          }, 8000);
        }
      } else {
        setQuickLimit(true)
        setTimeout(() => {
          setQuickLimit(false)
        }, 8000)
      }
    }
  };
  const saveStyles = {
    backgroundColor: "#2A82F6",
  };
  const publishStyles = {
    backgroundColor: "#2A82F6",
    opacity: 0.6,
  };
  const paperStyles = {};
  const styles = {
    BaseTextField: {
      width: "100%",
    },
    contents: {
      paddingTop: 20,
      paddingBottom: 0,
      display: "flex",
      flexDirection: "column",
      background: "#FFF",
      width: "100%",
      marginTop: 70,
      marginLeft: "14%",
    },
  };
  const [checked, setChecked] = useState(true);
  let classProps = () => {
    const tempArray = [];
    col.forEach((column, index) => {
      tempArray.push(`class${index}`);
    });
    return tempArray;
  };
  const details = () => {
    console.log('details')
  }
  const changeClassProps = () => {
    const tempArray = classProps();
    tempArray[0] = "class15";
    return tempArray;
  };
  const handleCloseDraft = () => {
    setAlertModal(false)
  };
  const discardChanges = () => {
    setCheckChanges(false)
    setAlertModal(false)
    setValue(dischard_changes)
    setChecked(organizationData.quickAccess);
    setHomePageButton(organizationData.enablePage)
    setTitle(organizationData.title)
    if (unblockHandle) {
      unblockHandle.current()
    }
    if (saved_route) {
      props.history.push(saved_route)
    }
  };
  let col = [
    { type: "number", name: "serial_number", label: "NO.", width: 'auto' },
    { type: "link", name: "invoice_number", label: "Image", width: 'auto' },
    { type: "string", name: "name", label: "Title", width: '40%' },
    { type: "string", name: "date", label: "Category", width: '15%' },
    { type: "string", name: "date/time", label: "Publish Date", width: '15%' },
    {
      type: "string",
      name: "date/time",
      label: "UnPublish Date",
      width: '15%',
    },
    { type: "string", name: "date", label: "STATUS", width: '15%' },
    { type: "action", name: "action", label: "ACTION", width: '10%' },
  ];
  const style = {
    width: 470,
    marginLeft: 800
  };
  const Alertstyle = {
    width: 470,
    marginLeft: '35%'
  };
  return (
    <MasterLayoutMiddle
      header={
        <>
          <PageHeaderWithTabs
            back={() => props.history.push('/website/pages')}
            value={value}
            title="Reads/Views"
            object={object}
            disabled={changes ? false : true}
            indicatorColor="primary"
            style={{ color: "#2A82F6", border: "1px solid black" }}
            handleChange={(x, y) => handleChange(x, y)}
            indicatorColor="#2A82F6"
            saveStyles={saveStyles}
            publishStyles={publishStyles}
            hiddenDraft={true}
            paperStyles={paperStyles}
            saveChanges={() => saveChanges()}
            publish={() => publish()}
          />
          {
            showAlert && success && success === 'Publish' ? (
              <div style={{ zIndex: 9999, width: "60%", position: "fixed", top: 35, marginLeft: '70px' }}>
                <AlertAction
                  alert={Your_changes_has_been_published}
                  alertType={"success"}
                  onClick={() => setshowAlert(false)}
                />
              </div>
            ) : showAlert && success && (
              <div style={{ zIndex: 9999, width: "60%", position: "fixed", top: 35, marginLeft: '70px' }}>
                <AlertAction
                  alert={Your_changes_has_been_saved_as_draft}
                  alertType={"success"}
                  onClick={() => setshowAlert(false)}
                />
              </div>
            )
          }
          {
            props.alert.alertValue &&
            <div style={{ zIndex: 9999, width: "60%", position: "fixed", top: 35, marginLeft: '70px' }}>
              <AlertAction
                alert={props.alert.alertValue}
                alertType={"success"}
                onClick={() => props.alertHide()}
              />
            </div>
          }
          {
            error && error === "Invalid token" && (
              <div style={{ zIndex: 9999, width: "60%", position: "fixed", top: 35, marginLeft: '70px' }}>
                <AlertAction
                  alert={token_expired}
                  alertType={"error"}
                  onClick={() => seterror(false)}
                />
              </div>
            )
          }
          {
            QuickLimit && (
              <div style={{ zIndex: 9999, width: "60%", position: "fixed", top: 35, marginLeft: '70px' }}>
                <AlertAction
                  alert={quick_access_limit_axeeded}
                  alertType={"error"}
                  onClick={() => setQuickLimit(false)}
                />
              </div>
            )
          }
        </>
      }
      content={
        Loader ?
          <div
            style={{
              marginTop: 30,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <CircularProgress color="primary" />
          </div>
          :
          <>
            <div>
              <div>
                <AlertDialogueAdvance
                  title="You have unsaved changes!"
                  description='There are unsaved changes. If you would like to save changes, press the "SAVE AS DRAFT" button.'
                  cancelText="Discard Changes"
                  confirmText="SAVE AS DRAFT"
                  open={open}
                  handleCancel={() => saveChanges()}
                  handleClose={() => handleCloseDraft()}
                  handleConfirm={() => discardChanges()}
                  styles={Alertstyle}
                />
              </div>
              {value === 1 && (
                <div className="page_body">
                  <Typography className="page_form_title">Page Settings</Typography>
                  <Grid className="form_body">
                    <Grid container item xs={6} spacing={3} >
                      <Grid item xs={12}>
                        <div className="field_box">
                          <BaseTextField
                            value={Title}
                            onChange={(e) => {
                              setTitle(e.target.value); checkChanges(true); setErrorFound(false)
                            }}
                            InputProps={false}
                            style={styles.BaseTextField}
                            color="primary"
                            disabled={false}
                            error={ErrorFound}
                            helperText="The page title appears in the top of the browser window."
                            label="Page Title"
                            count={20}
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <div className="page_switch">
                          <FormSwitch
                            style={styles.BaseTextField}
                            headline="Enable Page"
                            body="Disabled pages can’t be accessed by your site visitors."
                            values={homepageButton}
                            handleSwitchChange={() => { setHomePageButton(!homepageButton); checkChanges(true) }}
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <div className="SolidBorder no_space"></div>
                        <div className="checkBox">
                          <BaseCheckBox
                            label="Quick Access"
                            checked={checked}
                            color="secondary"
                            showHelperText={true}
                            helperText="Add to left navigation under QUICK ACCESS for quickly accessing the page"
                            onChange={(e) => { setChecked(e.target.checked); checkChanges(true) }}
                          />
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              )}
              {value === 0 && (
                <>
                  {
                    News.length > 0 ?
                      <SimpleTable
                        showHeader={true}
                        title="Reads/Views"
                        width="98%"
                        rows={News}
                        columns={col}
                        colSpan={16}
                        actionSendButton={true}
                        classProps={changeClassProps()}
                        donationsCount={News?.length > 0 ? 1 : 0}
                        noTitle="No News added"
                        noPara="Added News will be displayed and managed here"
                        noBtnText="Add New News"
                        onInviteClick={() =>
                          props.history.push({ pathname: "/website/add-news-articles", state: { canBeFeatured: canBeFeatured } })
                        }
                        actionLink={(name) => details(name)}
                        showIconCol={true}
                        editIcon={Edit}
                        deleteIcon={Delete}
                        editAction={(e) =>
                          props.history.push({ pathname: `/website/edit-news-articles/${e[0]._id}`, state: { canBeFeatured: canBeFeatured } })
                        }
                        deleteAction={(e) => DeleteAlertFunc(e)}
                        showFooter={true}
                        showAdd={true}
                        rowsPerPage={5}
                        addText="ADD NEW"
                        onAddClick={() =>
                          props.history.push({ pathname: "/website/add-news-articles", state: { canBeFeatured: canBeFeatured } })
                        }
                        iconTextSize={16}
                        sortColumnIndex={[4]}
                      />
                      :
                      <EmptyTable
                        title="Reads/Views"
                        onAddClick={() => props.history.push("/website/add-news-articles")}
                        addLabel="ADD NEW"
                        noBtnText="ADD NEW"
                      />
                  }
                  <div>
                    <AlertDialogue
                      title="Delete Reads/Views?"
                      description="Are you sure you want to delete this Reads/Views?"
                      description2="Deleting will permanently remove from Website."
                      cancelText="Cancel"
                      confirmText="Confirm"
                      open={openAlert}
                      handleCancel={() => handleCancel()}
                      handleClose={() => handleClose()}
                      handleConfirm={() => deleteServiceAction(specificRow)}
                      styles={style}
                    />
                  </div>
                </>
              )}
            </div>
          </>
      }
      isFooter={true}
      footer={
        <FooterInner
          style={style}
          termsLink={process.env.REACT_APP_Environment === 'dev' ? "http://shapla.deenconnect.io/terms-policies" : "http://deenconnect.io/terms-policies"}
          privacyLink={process.env.REACT_APP_Environment === 'dev' ? "http://shapla.deenconnect.io/terms-policies#privacy-policy" : "http://deenconnect.io/terms-policies#privacy-policy"}
        />
      }
    />
  );
}
const mapStateToProps = (state) => {
  return {
    pages: state.pages,
    alert: state.alert,
  };
};
const mapDispatchToProps = (dispatch) => ({
  dispatchPagesAction: (data) => dispatch(PagesAction(data)),
  alertHide: (res) => dispatch(hideAlert(res)),
  alertShow: (res) => dispatch(showAlert(res)),
});
export default connect(mapStateToProps, mapDispatchToProps)(NewsArticles);



